'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _themeSections = require('@shopify/theme-sections');

require('../../styles/sections/template-blog-article.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('template-blog-article', {
  onLoad: function onLoad() {
    if ((0, _jquery2.default)('#anchor-blog-articles').length) {
      (0, _jquery2.default)('html, body').animate({
        scrollTop: (0, _jquery2.default)('#anchor-blog-articles').offset().top - 130
      }, 2000);
    }

    var dropdownNavs = document.querySelectorAll('[data-blog-dropdown-nav]');
    if (dropdownNavs) {
      dropdownNavs.forEach(function (nav, index) {
        nav.addEventListener('change', function (event) {
          if (event.target.checked) {
            window.location.href = event.target.value;
          }
        }.bind(this));
      }.bind(this));
    }
  },


  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload: function onUnload() {}
});